import Link from "@/components/ui/link";
import {
  mentionColorClass,
  type ResolvedMention,
  resolveMentionHref,
  segmentTextByMentions,
} from "@/lib/mentions";
import { cn } from "@/lib/utils";

type ReviewTextProps = {
  text: string | null | undefined;
  mentions?: ResolvedMention[];
  className?: string;
};

export function ReviewText({ text, mentions, className }: ReviewTextProps) {
  const content = text?.trim();
  if (!content) return null;

  const segments = segmentTextByMentions(content, mentions);
  let cursor = 0;

  return (
    <p
      className={cn(
        "leading-relaxed break-words whitespace-pre-line",
        className,
      )}
    >
      {segments.map((segment) => {
        const start = cursor;
        cursor += segment.value.length;
        const key = `${segment.kind}-${start}-${cursor}-${segment.value}`;

        if (segment.kind === "text") {
          return <span key={key}>{segment.value}</span>;
        }

        const href = resolveMentionHref(segment.mention);
        const mentionClass = cn(
          "font-semibold hover:underline",
          mentionColorClass(segment.mention.type),
        );

        if (!href) {
          return (
            <span key={key} className={mentionClass}>
              {segment.value}
            </span>
          );
        }

        return (
          <Link key={key} href={href} className={mentionClass}>
            {segment.value}
          </Link>
        );
      })}
    </p>
  );
}
